import { MainNavProps } from "./navigation/main/MainParamList";
import { WebComponent } from "../components/WebComponent";

export function CommonWeb({ route }: MainNavProps<'CommonWeb'>) {
    const { title, url, showBack } = route.params
    return (<WebComponent title={title} url={url} navProps={{ showBack: showBack }} />)
}